/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { Container } from "inversify";
import { computed } from "vue";
import fechaComp from "../../../../../common/infrastructure/funcionescompartidas/fechaComp";
import { IapCatalog } from "../../../catalog/domain/iapCatalog";
import { TYPES } from "../../../../../common/domain/types";
import HelperLoading from "../../../../../common/infrastructure/funciones/HelperLoading";
import SqlTypesConst from "../../../../../common/domain/constantes/SqlTypesConst";
import HelperCommon from "../../../../../common/infrastructure/funciones/HelperCommon";
//import { IServiceComponentDataSourceField } from "../../../component/application/IServiceComponentDataSourceField";
import ProductQuestionTypeConst from "../../../../../common/domain/constantes/ProductQuestionTypeConst";
import GestionConst from "../../../../../common/domain/constantes/GestionConst";
import { IServiceCatalog } from "../../../catalog/application/IServiceCatalog";
import { IapComponentDataSource } from "../../../component/domain/iapComponentDataSource";
import { IServiceComponentDataSource } from "../../../component/application/IServiceComponentDataSource";
import { IapDataSourceField } from "../../../datasource/domain/iapDataSourceField";
import { fetchWrapper } from "../../../../../common/infrastructure/funciones/helperFetch";
import Environment from "../../../../../common/domain/constantes/environment";
import DataSourceConst from "./dataSourceConst";
import { IapDataSource } from "../../../datasource/domain/iapDataSource";
import { clave } from "../../../dataupdate/domain/clave";
import OperationDataTypeConst from "../../../../../common/domain/constantes/OperationDataTypeConst";
import { ExpresionEngine } from "../../../expression/infrastructure/helper/expressionEngine";
import { LocalService } from "../../../../../common/infrastructure/servicios";
import CatalogObjectTypeConst from "../../../catalog/domain/const/CatalogObjectTypeConst";
import CatalogExpConst from "../../../catalog/domain/const/CatalogExpConst";
import HelperUtils from "../../../../../common/infrastructure/funciones/HelperUtils";

export default function DataSourceUtilComp(
  compDataSource: IapComponentDataSource,
  store:any
) {

  
  const { formateaFecha } = fechaComp();



  const isType = (item: IapDataSourceField, tipo: string) => {
    return item.sqlType == tipo;
  };


  const isIdCampoType = (item: IapDataSourceField, tipo: string) => {
    return item.idDataType == tipo;
  };


  const isCatalogType = (item: IapDataSourceField) => {
    return !HelperCommon.isNullOrWhitespace(item.catalogTypeId ?? "")
  };

  const hasLookUpType = (item: IapDataSourceField) => {
    return item.dataSourceLookUpId !== null
  };

  const hasLookUpByFieldId = (key: string) => {

    let outPut = false
    const item = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == key)
    if (item) {
      outPut = hasLookUpType(item);
    }

    return outPut
  }

  const hasLookUpByFieldType = (key: string, typeId:string) => {

    let outPut = false
    const item = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == key)

    if (item) {
      outPut = hasLookUpType(item) && isIdCampoType(item,typeId);
    }

    return outPut
  }

  const getLookUpByFieldId = (key: string) => {

    const item = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == key)

    if (item) {
      return item.dataSourceLookUp;
    }

  }

  const isTableType = (item: IapDataSourceField) => {
    return (
      item?.foreignTableName?.toLocaleLowerCase() !== DataSourceConst.CAT.toLowerCase() &&
      (!HelperCommon.isNullOrWhitespace(
        item.catalogTypeId ?? ""
      ))
    );
  };

  const isCatalogTypeByFieldId = (key: string) => {
    let outPut = false
    const item = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == key)
    if (item) {
      outPut = isCatalogType(item)
    }

    return outPut
  };

  const isFilterVisible = (item: IapDataSourceField) => {
    return (isType(item, SqlTypesConst.VARCHAR) || isType(item, SqlTypesConst.NVARCHAR)) && !isCatalogType(item)
  }


  const isColumnType = (columna: string, tipo: string) => {

    var item = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
    if (item) {
      return isType(item, tipo);
    }

    return false;
  }

  const isColumnIdtipoCampoType = (columna: string, tipo: string) => {
    var item = (tablasData.value as IapDataSourceField[]).find(x =>
      ((dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
      ||
      ((dataBaseId.value + DataSourceConst.DELIMITERFIELDS + DataSourceConst.AGGREGATE_TABLE + DataSourceConst.DELIMITERFIELDS + x.fieldAlias) == columna)
    )
    if (item) {
      return isIdCampoType(item, tipo);
    }

    return false;
  }


  const formatData = (data: any, columna: string) => {
    var data = data[columna];
    var field = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna);

    if (field) {
      if (isType(field, SqlTypesConst.DATETIME) || isType(field, SqlTypesConst.TIME) || isType(field, SqlTypesConst.DATE)) {
        data = formateaFecha(data);
      }
      /*if (isType(field, SqlTypesConst.BIT)) {
        data = ((data ?? false)) === false ? 'No' : 'Sí';
      }
      */
      if (isType(field, SqlTypesConst.MONEY) || isType(field, SqlTypesConst.DECIMAL)) {
        data = HelperCommon.formateaMoneda(data);
      }
      /*
      if (isType(field, SqlTypesConst.VARCHAR) && isCatalogType(field)) {
        //data = catalogos.value.find(x => x.id == data)?.description;
      }
      */

    }
    return data;
  }

  const mustFormatData = (columna: string) => {
    if (tablasData.value) {
      var field = (tablasData.value as IapDataSourceField[]).find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna);
      if (field) {
        if (isType(field, SqlTypesConst.DATETIME) || isType(field, SqlTypesConst.TIME) || isType(field, SqlTypesConst.DATE)) {
          return true
        }
        if (isType(field, SqlTypesConst.BIT)) {
          return false
        }
        if (isType(field, SqlTypesConst.MONEY) || isType(field, SqlTypesConst.DECIMAL)) {
          return true
        }
        if (isType(field, SqlTypesConst.VARCHAR) && isCatalogType(field)) {
          return false
        }

      }
      return false;
    }
    return false;
  }

  const generateFormatCol = (_data: any) => {

    _data.forEach((data: {}) => {
      const keys = Object.keys(data);
      keys.forEach(k => {
        if (mustFormatData(k)) {
          const colName = k + DataSourceConst.DELIMITERFIELDFORMAT
          const zz = data as any
          zz[colName] = formatData(data, k)
        }
      })

    })
  }



  const getPrimaryKeys = (dsData: IapDataSource, data: any, tableName: string): clave[] => {
    const _outputData: clave[] = [];
    const keys = dsData.iapDataSourceFields.filter(x => x.tableName == tableName && x.primaryKey).map(x =>
      dsData?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field
    );
    keys.forEach(k => {
      _outputData.push({
        dataBase: dsData?.iapDataSourceDataBase?.idBaseDatos as any,
        table: tableName,
        field: k,
        value: data[k]
      })
    })

    return _outputData;
  }

  const getDefaultvalueDataBase = (data: IapDataSourceField) => {
    if (data.defaultValue) {
      const i = data.defaultValue.startsWith('((') ? 2 : 1;
      let _valor = data.defaultValue.substring(i, data.defaultValue.length - i) 
      //@ts-ignore:disable-next-line
      _valor = _valor.replaceAll('(', '').replaceAll(')', '')
      if (_valor.toLocaleLowerCase() == 'getdate') {
          return new Date()
      }
      if (_valor.toLocaleLowerCase() == 'getcurrentuser') {
          return store.getters.currentUser.id
      }
      if (_valor.toLocaleLowerCase() == 'newid') {
        return store.getters.currentUser.id
    }

      if (data.defaultValue.toLocaleLowerCase() == 'getdate()') {
          return new Date()
      }
      if (data.defaultValue.toLocaleLowerCase() =='newid()') {
        return HelperUtils.newGuid()          
      }
      if (data.defaultValue.toLocaleLowerCase() == 'getcurrentuser()') {
          return store.getters.getCurrentUser.id
      }

      if (isType(data, SqlTypesConst.BIT)) {
          return Boolean(JSON.parse(_valor))
      }
      else {
          return _valor
      }

  }

  return null;
  }
  const getValuesWithoutPrimaryKeys = (dsData: IapDataSource, data: any, tableName: string, operationType: number): clave[] => {
    const _outputData: clave[] = [];
    const notKeys = dsData.iapDataSourceFields.filter(x => x.tableName == tableName && (!x.primaryKey || (x.primaryKey && operationType == OperationDataTypeConst.INSERT))).map(x => ({
      fullId: dsData?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field,
      id: x.id
    }));
    notKeys.forEach(k => {
      const dsf = dsData.iapDataSourceFields.find(x => x.id == k.id);
      if (data[k.fullId] || /*(!data[k.fullId] && dsf?.defaultValue && */operationType == OperationDataTypeConst.INSERT/*)*/) {
        _outputData.push({
          dataBase: dsData?.iapDataSourceDataBase?.idBaseDatos as any,
          table: tableName,
          field: k.fullId,
          value: dsf && dsf.defaultValue && !data[k.fullId] ? getDefaultvalueDataBase(dsf) : data[k.fullId]
        })
      }
    })

    return _outputData;
  }


  const tablas = computed(() => {
    return compDataSource.dataSource.iapDataSourceTableAliases;
  })

  const tablasData = computed(() => {
    return compDataSource.dataSource.iapDataSourceFields
  })

  const dataBaseId = computed(() => {
    return compDataSource.dataSource?.iapDataSourceDataBase?.idBaseDatos
  })


  return {

    tablas,
    tablasData,
    dataBaseId,
    //getTables,
    isType,
    isCatalogType,
    isCatalogTypeByFieldId,
    isFilterVisible,
    isIdCampoType,
    isColumnType,
    isColumnIdtipoCampoType,
    formatData,
    generateFormatCol,
    mustFormatData,
    isTableType,
    getPrimaryKeys,
    getValuesWithoutPrimaryKeys,
    hasLookUpType,
    hasLookUpByFieldId,
    getLookUpByFieldId,
    hasLookUpByFieldType    
  };
}


